export default __webpack_public_path__ + "1165164c862d7b1af9ccefaf10a991ad.svg";